var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { observer } from "mobx-react";
import { Icon, Img, FreeHtml } from "sb-resp-ui";
import { LiveIndicator, EventText } from "../../components";
import { getMBNComponentHelper } from "../../../../helpers";
let SuperBannerImage = class SuperBannerImage extends React.PureComponent {
    render() {
        var _a;
        const { item, liveIndicator, tooltip } = this.props;
        const clsMdf = getClassName(item);
        const mbnComponent = getMBNComponentHelper(item.ImageUIProps.isMBNEnabled, (_a = item.EventUIPops) === null || _a === void 0 ? void 0 : _a.pickedEvent);
        return (React.createElement("div", { className: "rj-superbanner__image-row", "data-uat": "superbanner-image-row" },
            React.createElement("a", { className: "rj-superbanner__img-link", href: item.ImageUIProps.link, onClick: (e) => { var _a; return this.props.onClick(e, (_a = item.EventUIPops) === null || _a === void 0 ? void 0 : _a.pickedEvent, item.ImageUIProps.imageLink); }, style: item.ImageUIProps.styles, "data-uat": "link-superbanner-img" },
                React.createElement(Img, { width: "100%", height: item.ImageUIProps.styles.height, src: item.ImageUIProps.ImageSrc || "", fallbackSrc: "/imgs/i/o/superbanner/fallback.svg" }),
                item.ImageUIProps.leagueName && React.createElement(EventText, { text: item.ImageUIProps.leagueName, modifier: item.ImageUIProps.modifierLeague }),
                React.createElement("div", { className: clsMdf, "data-uat": "wrapper-superbaner-icon-live" },
                    mbnComponent,
                    item.ImageUIProps.isLive && React.createElement(LiveIndicator, { liveText: liveIndicator }),
                    item.ImageUIProps.hasLivestream && React.createElement("div", Object.assign({ className: "rj-superbaner__icon-live-stream-wrapper" }, tooltip),
                        React.createElement(Icon, { i: "i-24-16 i-o-ev-alt-streaming rj-superbaner__icon-live-stream " })))),
            item.ImageUIProps.FreeHtmlText && React.createElement(FreeHtml, { html: item.ImageUIProps.FreeHtmlText })));
    }
};
SuperBannerImage = __decorate([
    observer
], SuperBannerImage);
export { SuperBannerImage };
function getClassName(item) {
    return item.ImageUIProps.isMBNEnabled && (item.ImageUIProps.hasLivestream || item.ImageUIProps.isLive)
        ? "rj-superbaner__icon rj-superbaner__icon--minbet-number-live-stream"
        : "rj-superbaner__icon";
}
//# sourceMappingURL=SuperBannerImage.js.map